

( function( $ ) {
	$( document ).ready( function() {
		if ( $( '.readmore' ) ) {
			$( '.readmore' ).readmore( {
				collapsedHeight: 110,
				moreLink: '<a href="#">Afficher la suite </a>',
				lessLink: '<a href="#">Fermer</a>',
			} );
		}
	} );
}( jQuery ) );
